import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { Tooltip, Typography } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";

const CashFareRange = (props: { min_cash_rate: number; max_cash_rate: number }) => {
  const { isMobile } = usePlatform();

  const range = [props.min_cash_rate, props.max_cash_rate];
  return (
    <Tooltip
      title={
        "Explore real cash fare comparisons for flights of the route(s) and date(s) you're searching for. Track how much you can save with us. Keep saving thousands and hours with AwardTool while exploring the world!"
      }
    >
      <div className={isMobile ? "flex items-center mr-[15px] mt-[2px] pb-[20px]" : "flex items-center mr-[15px] mt-[2px]"} >
        <MonetizationOnOutlinedIcon color="primary" sx={{ fontSize: 18, mt: 0.1 }} />
        <Typography color="primary" sx={{ fontSize: 15, pd: 0.2 }}>
          {isMobile ? "Save" : "Save"} ${Math.floor(range[0]).toLocaleString()} - $
          {Math.min(Math.floor(range[0] * 9), Math.floor(range[1])).toLocaleString()}
        </Typography>
      </div>
    </Tooltip>
  );
};

export default CashFareRange;
